<template>
  <div id="digital-pakke" class="animated fadeIn pt2 pb4 notosans">
    <!-- desktop view -->
    <div class="clearfix adjust">
      <div class="flex flex-wrap justify-start mt2 mb2">
        <div class="col-12 px0">
            <p class="h4 darkblue semi-bold">
              Digital pakke
            </p>
          <div class="flex col-12">
            <div class="col-12 pt3 pb3 flex flex-column px0">
              <div class="">
                <button class="action-button p2 flex justify-start items-center h5 line-height-1" @click="gotoArtikel()"> Download din personlige pressemeddelelse</button>
              </div>
              <a type="button" class="green mr4 no-underline" href="static/pdf/Guide_digital_pakke_(til vindere).pdf" download>
                <p class="h5 line-height-1 flex items-center mt3">
                  <span class="inline-block mr1"><svg class="relative" style="top:2px;" fill="currentColor" height="24" viewBox="-58 1 511 511.999" width="24" xmlns="http://www.w3.org/2000/svg"><path d="m392.527344 431.265625-21.027344-35.050781 21.023438-35.050782c4.800781-7.996093 4.921874-17.617187.324218-25.734374-4.59375-8.117188-12.90625-12.960938-22.234375-12.960938h-24.4375v-270.570312c0-28.617188-23.28125-51.898438-51.898437-51.898438h-176.113282c-7.40625 0-14.625 1.753906-21.117187 4.996094-.035156.015625-.070313.027344-.105469.042968-.039062.023438-.074218.042969-.113281.0625-.382813.195313-.757813.402344-1.132813.605469-.324218.175781-.648437.347657-.96875.527344-.335937.191406-.660156.390625-.992187.589844-.363281.21875-.726563.441406-1.082031.667969-.285156.183593-.566406.371093-.847656.5625-.394532.261718-.785157.53125-1.171876.808593-.246093.175781-.492187.355469-.738281.539063-.410156.304687-.8125.621094-1.214843.9375-.21875.175781-.433594.347656-.648438.523437-.417969.347657-.828125.703125-1.234375 1.0625-.191406.171875-.386719.335938-.574219.511719-.429687.394531-.851562.800781-1.265625 1.210938-.15625.15625-.316406.300781-.46875.457031-.5625.574219-1.113281 1.15625-1.648437 1.757812l-23.46875 26.402344-46.9375 52.800781c-.0625.070313-.121094.144532-.183594.21875-.390625.445313-.777344.894532-1.152344 1.355469-.183594.226563-.359375.460937-.539062.691406-.242188.308594-.484375.617188-.71875.929688-.222656.296875-.429688.597656-.644532.898437-.175781.25-.355468.496094-.527343.75-.242188.359375-.476563.722656-.710938 1.085938-.121093.195312-.25.386718-.371093.582031-.261719.425781-.515626.855469-.761719 1.285156-.078125.132813-.15625.265625-.230469.402344-.277344.488281-.542969.984375-.800781 1.484375-.039063.070312-.074219.140625-.109375.210938-.285156.554687-.558594 1.117187-.816406 1.683593-.007813.011719-.011719.023438-.019532.035157-2.835937 6.15625-4.347656 12.890624-4.347656 19.785156v333.636718c0 28.617188 23.28125 51.898438 51.898438 51.898438h241.882812c25.242188 0 46.328125-18.125 50.945312-42.039062h25.390626c9.324218 0 17.636718-4.847657 22.234374-12.964844 4.59375-8.113282 4.472657-17.734375-.324218-25.730469zm-301.09375-394.964844v59.34375c0 3.667969-2.984375 6.652344-6.652344 6.652344h-52.015625zm202.84375 455.699219h-241.878906c-17.589844 0-31.902344-14.308594-31.902344-31.898438v-333.636718c0-1.402344.117187-2.796875.328125-4.167969h63.957031c14.695312 0 26.652344-11.957031 26.652344-26.652344v-74.789062c2.179687-.558594 4.441406-.855469 6.730468-.855469h176.113282c17.589844 0 31.898437 14.308594 31.898437 31.898438v270.570312h-175.417969c-13.046874 0-23.664062 10.617188-23.664062 23.664062v85.160157c0 21.320312 17.34375 38.667969 38.664062 38.667969h158.859376c-4.164063 12.777343-16.191407 22.039062-30.339844 22.039062zm81.167968-44.855469c-.480468.847657-1.910156 2.816407-4.832031 2.816407h-204.855469c-1.929687 0-3.792968-.292969-5.542968-.839844-7.59375-2.367188-13.125-9.464844-13.125-17.828125v-85.15625c0-2.023438 1.648437-3.667969 3.667968-3.667969h219.855469c2.921875 0 4.351563 1.96875 4.832031 2.816406.480469.84375 1.433594 3.085938-.070312 5.589844l-22.308594 37.191406c-3.015625 5.027344-3.015625 11.273438 0 16.292969l22.308594 37.191406c1.503906 2.507813.550781 4.746094.070312 5.59375zm0 0"/><path d="m176.308594 414.75c-2.109375 0-3.902344.769531-5.324219 2.285156-1.398437 1.488282-2.109375 3.296875-2.109375 5.375 0 2.082032.707031 3.890625 2.109375 5.378906 1.421875 1.515626 3.214844 2.285157 5.324219 2.285157 1.996094 0 3.742187-.785157 5.195312-2.328125 1.429688-1.519532 2.152344-3.3125 2.152344-5.335938 0-2.082031-.726562-3.894531-2.164062-5.390625-1.453126-1.503906-3.195313-2.269531-5.183594-2.269531zm0 0"/><path d="m215.964844 360.277344h-18.21875c-1.703125 0-3.117188.492187-4.214844 1.46875-1.128906 1.003906-1.726562 2.269531-1.726562 3.65625v58.914062c0 1.179688.429687 2.835938 2.46875 4.015625 1.371093.796875 3.027343 1.199219 4.921874 1.199219 1.828126 0 3.464844-.398438 4.859376-1.191406 2.09375-1.179688 2.53125-2.839844 2.53125-4.023438v-19.527344h8.652343c6.742188 0 12.269531-1.796874 16.425781-5.34375 4.226563-3.601562 6.371094-9.230468 6.371094-16.730468v-.542969c0-7.425781-2.0625-13.003906-6.128906-16.578125-4.007812-3.527344-9.375-5.316406-15.941406-5.316406zm7.289062 23.34375c0 3.03125-.699218 5.304687-2.082031 6.761718-1.378906 1.453126-3.320313 2.160157-5.933594 2.160157h-8.652343v-18.933594h8.652343c2.613281 0 4.554688.707031 5.933594 2.160156 1.382813 1.457031 2.082031 3.734375 2.082031 6.761719zm0 0"/><path d="m284.191406 365.625c-4.132812-3.546875-9.675781-5.347656-16.476562-5.347656h-16.042969c-1.835937 0-3.390625.46875-4.617187 1.386718-1.691407 1.273438-2.046876 2.734376-2.046876 3.738282v59.003906c0 1.003906.355469 2.46875 2.046876 3.734375 1.226562.921875 2.78125 1.390625 4.617187 1.390625h16.042969c6.804687 0 12.347656-1.800781 16.476562-5.347656 4.195313-3.605469 6.320313-9.292969 6.320313-16.90625v-24.746094c0-7.609375-2.125-13.300781-6.320313-16.90625zm-8.460937 41.652344c0 6.085937-2.546875 8.921875-8.015625 8.921875h-7.925782v-42.589844h7.925782c5.46875 0 8.015625 2.835937 8.015625 8.921875zm0 0"/><path d="m338.589844 360.277344h-31.632813c-1.675781 0-3.171875.417968-4.4375 1.238281-1.457031.941406-2.226562 2.316406-2.226562 3.976563v58.824218c0 1.179688.429687 2.835938 2.46875 4.015625 1.371093.796875 3.027343 1.199219 4.921875 1.199219 1.828125 0 3.464844-.398438 4.859375-1.191406 2.09375-1.179688 2.53125-2.839844 2.53125-4.023438v-23.335937h12.367187c1.640625 0 2.988282-.691407 3.902344-1.996094.8125-1.160156 1.222656-2.515625 1.222656-4.035156 0-1.636719-.410156-3.054688-1.222656-4.210938-.914062-1.308593-2.261719-2-3.902344-2h-12.367187v-15.128906h23.515625c1.671875 0 3.039062-.777344 3.949218-2.25.78125-1.261719 1.175782-2.777344 1.175782-4.507813 0-1.660156-.378906-3.125-1.125-4.355468-.878906-1.449219-2.261719-2.21875-4-2.21875zm0 0"/><path d="m91.839844 166h163.210937c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-163.210937c-5.519532 0-10 4.476562-10 10s4.480468 10 10 10zm0 0"/><path d="m255.050781 206h-.023437c-5.523438 0-9.988282 4.476562-9.988282 10s4.488282 10 10.011719 10c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10zm0 0"/><path d="m91.839844 226h123.210937c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-123.210937c-5.519532 0-10 4.476562-10 10s4.480468 10 10 10zm0 0"/><path d="m265.050781 276c0-5.523438-4.476562-10-10-10h-163.210937c-5.519532 0-10 4.476562-10 10s4.480468 10 10 10h163.210937c5.523438 0 10-4.476562 10-10zm0 0"/></svg></span>
                  <span class="inline-block">Download din guide her (til vindere)</span>
                </p>
              </a>
              <a type="button" class="green no-underline" href="static/pdf/Guide_digital_pakke_(til finalister).pdf" download>
                <p class="h5 line-height-1 flex items-center mt3">
                  <span class="inline-block mr1"><svg class="relative" style="top:2px;" fill="currentColor" height="24" viewBox="-58 1 511 511.999" width="24" xmlns="http://www.w3.org/2000/svg"><path d="m392.527344 431.265625-21.027344-35.050781 21.023438-35.050782c4.800781-7.996093 4.921874-17.617187.324218-25.734374-4.59375-8.117188-12.90625-12.960938-22.234375-12.960938h-24.4375v-270.570312c0-28.617188-23.28125-51.898438-51.898437-51.898438h-176.113282c-7.40625 0-14.625 1.753906-21.117187 4.996094-.035156.015625-.070313.027344-.105469.042968-.039062.023438-.074218.042969-.113281.0625-.382813.195313-.757813.402344-1.132813.605469-.324218.175781-.648437.347657-.96875.527344-.335937.191406-.660156.390625-.992187.589844-.363281.21875-.726563.441406-1.082031.667969-.285156.183593-.566406.371093-.847656.5625-.394532.261718-.785157.53125-1.171876.808593-.246093.175781-.492187.355469-.738281.539063-.410156.304687-.8125.621094-1.214843.9375-.21875.175781-.433594.347656-.648438.523437-.417969.347657-.828125.703125-1.234375 1.0625-.191406.171875-.386719.335938-.574219.511719-.429687.394531-.851562.800781-1.265625 1.210938-.15625.15625-.316406.300781-.46875.457031-.5625.574219-1.113281 1.15625-1.648437 1.757812l-23.46875 26.402344-46.9375 52.800781c-.0625.070313-.121094.144532-.183594.21875-.390625.445313-.777344.894532-1.152344 1.355469-.183594.226563-.359375.460937-.539062.691406-.242188.308594-.484375.617188-.71875.929688-.222656.296875-.429688.597656-.644532.898437-.175781.25-.355468.496094-.527343.75-.242188.359375-.476563.722656-.710938 1.085938-.121093.195312-.25.386718-.371093.582031-.261719.425781-.515626.855469-.761719 1.285156-.078125.132813-.15625.265625-.230469.402344-.277344.488281-.542969.984375-.800781 1.484375-.039063.070312-.074219.140625-.109375.210938-.285156.554687-.558594 1.117187-.816406 1.683593-.007813.011719-.011719.023438-.019532.035157-2.835937 6.15625-4.347656 12.890624-4.347656 19.785156v333.636718c0 28.617188 23.28125 51.898438 51.898438 51.898438h241.882812c25.242188 0 46.328125-18.125 50.945312-42.039062h25.390626c9.324218 0 17.636718-4.847657 22.234374-12.964844 4.59375-8.113282 4.472657-17.734375-.324218-25.730469zm-301.09375-394.964844v59.34375c0 3.667969-2.984375 6.652344-6.652344 6.652344h-52.015625zm202.84375 455.699219h-241.878906c-17.589844 0-31.902344-14.308594-31.902344-31.898438v-333.636718c0-1.402344.117187-2.796875.328125-4.167969h63.957031c14.695312 0 26.652344-11.957031 26.652344-26.652344v-74.789062c2.179687-.558594 4.441406-.855469 6.730468-.855469h176.113282c17.589844 0 31.898437 14.308594 31.898437 31.898438v270.570312h-175.417969c-13.046874 0-23.664062 10.617188-23.664062 23.664062v85.160157c0 21.320312 17.34375 38.667969 38.664062 38.667969h158.859376c-4.164063 12.777343-16.191407 22.039062-30.339844 22.039062zm81.167968-44.855469c-.480468.847657-1.910156 2.816407-4.832031 2.816407h-204.855469c-1.929687 0-3.792968-.292969-5.542968-.839844-7.59375-2.367188-13.125-9.464844-13.125-17.828125v-85.15625c0-2.023438 1.648437-3.667969 3.667968-3.667969h219.855469c2.921875 0 4.351563 1.96875 4.832031 2.816406.480469.84375 1.433594 3.085938-.070312 5.589844l-22.308594 37.191406c-3.015625 5.027344-3.015625 11.273438 0 16.292969l22.308594 37.191406c1.503906 2.507813.550781 4.746094.070312 5.59375zm0 0"/><path d="m176.308594 414.75c-2.109375 0-3.902344.769531-5.324219 2.285156-1.398437 1.488282-2.109375 3.296875-2.109375 5.375 0 2.082032.707031 3.890625 2.109375 5.378906 1.421875 1.515626 3.214844 2.285157 5.324219 2.285157 1.996094 0 3.742187-.785157 5.195312-2.328125 1.429688-1.519532 2.152344-3.3125 2.152344-5.335938 0-2.082031-.726562-3.894531-2.164062-5.390625-1.453126-1.503906-3.195313-2.269531-5.183594-2.269531zm0 0"/><path d="m215.964844 360.277344h-18.21875c-1.703125 0-3.117188.492187-4.214844 1.46875-1.128906 1.003906-1.726562 2.269531-1.726562 3.65625v58.914062c0 1.179688.429687 2.835938 2.46875 4.015625 1.371093.796875 3.027343 1.199219 4.921874 1.199219 1.828126 0 3.464844-.398438 4.859376-1.191406 2.09375-1.179688 2.53125-2.839844 2.53125-4.023438v-19.527344h8.652343c6.742188 0 12.269531-1.796874 16.425781-5.34375 4.226563-3.601562 6.371094-9.230468 6.371094-16.730468v-.542969c0-7.425781-2.0625-13.003906-6.128906-16.578125-4.007812-3.527344-9.375-5.316406-15.941406-5.316406zm7.289062 23.34375c0 3.03125-.699218 5.304687-2.082031 6.761718-1.378906 1.453126-3.320313 2.160157-5.933594 2.160157h-8.652343v-18.933594h8.652343c2.613281 0 4.554688.707031 5.933594 2.160156 1.382813 1.457031 2.082031 3.734375 2.082031 6.761719zm0 0"/><path d="m284.191406 365.625c-4.132812-3.546875-9.675781-5.347656-16.476562-5.347656h-16.042969c-1.835937 0-3.390625.46875-4.617187 1.386718-1.691407 1.273438-2.046876 2.734376-2.046876 3.738282v59.003906c0 1.003906.355469 2.46875 2.046876 3.734375 1.226562.921875 2.78125 1.390625 4.617187 1.390625h16.042969c6.804687 0 12.347656-1.800781 16.476562-5.347656 4.195313-3.605469 6.320313-9.292969 6.320313-16.90625v-24.746094c0-7.609375-2.125-13.300781-6.320313-16.90625zm-8.460937 41.652344c0 6.085937-2.546875 8.921875-8.015625 8.921875h-7.925782v-42.589844h7.925782c5.46875 0 8.015625 2.835937 8.015625 8.921875zm0 0"/><path d="m338.589844 360.277344h-31.632813c-1.675781 0-3.171875.417968-4.4375 1.238281-1.457031.941406-2.226562 2.316406-2.226562 3.976563v58.824218c0 1.179688.429687 2.835938 2.46875 4.015625 1.371093.796875 3.027343 1.199219 4.921875 1.199219 1.828125 0 3.464844-.398438 4.859375-1.191406 2.09375-1.179688 2.53125-2.839844 2.53125-4.023438v-23.335937h12.367187c1.640625 0 2.988282-.691407 3.902344-1.996094.8125-1.160156 1.222656-2.515625 1.222656-4.035156 0-1.636719-.410156-3.054688-1.222656-4.210938-.914062-1.308593-2.261719-2-3.902344-2h-12.367187v-15.128906h23.515625c1.671875 0 3.039062-.777344 3.949218-2.25.78125-1.261719 1.175782-2.777344 1.175782-4.507813 0-1.660156-.378906-3.125-1.125-4.355468-.878906-1.449219-2.261719-2.21875-4-2.21875zm0 0"/><path d="m91.839844 166h163.210937c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-163.210937c-5.519532 0-10 4.476562-10 10s4.480468 10 10 10zm0 0"/><path d="m255.050781 206h-.023437c-5.523438 0-9.988282 4.476562-9.988282 10s4.488282 10 10.011719 10c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10zm0 0"/><path d="m91.839844 226h123.210937c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-123.210937c-5.519532 0-10 4.476562-10 10s4.480468 10 10 10zm0 0"/><path d="m265.050781 276c0-5.523438-4.476562-10-10-10h-163.210937c-5.519532 0-10 4.476562-10 10s4.480468 10 10 10h163.210937c5.523438 0 10-4.476562 10-10zm0 0"/></svg></span>
                  <span class="inline-block">Download din guide her (til finalister)</span>
                </p>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- This will render if image doesnt exist -->
      <img class="hide" rel="preload" :src="'https://widget.haandvaerker.dk/prisen/winnersBadge/mail/mailSignaturePng.php?id='+haaId" v-if="renderMail">
      <img class="hide" rel="preload" :src="'https://widget.haandvaerker.dk/prisen/winnersBadge/mailsmall/mailSignaturePng.php?id='+haaId" v-if="renderMailSmall">
      <img class="hide" rel="preload" :src="'https://widget.haandvaerker.dk/prisen/winnersBadge/streamer/streamerPng.php?id='+haaId" v-if="renderStreamer">
      <img class="hide" rel="preload" :src="'https://widget.haandvaerker.dk/klima/klimaPng.php?id='+haaId" v-if="renderklima">
      <!-- klimabadge -->
      <div id="klimabadge"  class="hide col-12">
            <div href="/Klima" class="no-underline flex flex-column mr-auto green-background justify-center items-center lg-col-4 md-col-5 white p1 overflow-hidden imageShadow badgeImg background-cover relative imageShadow mr1"  
                      style="background-repeat:no-repeat;background-position: top center;height:clamp(300px,25vw,480px);border-radius: 30px;">
                        <div class="center mb3 absolute top-0" style="top: 6%;">
                          <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" alt="klima badge" role="img" data-name="Layer 1" width="clamp(110px,18vw,180px)" viewBox="0 0 977.57 1200">
                            <path fill="#fff" d="M977,179.83c-30.21,69.82-149.92,308.36-337.51,204.84-5.49-3-4.64-11.11,1.46-12.52,72.29-16.63,192.44-56.39,266.43-145.69,0,0-93,91.87-270.62,112.24h-.07c-.08,0-.25,0-.46.05-.67.08-18.73,3-30,10.29,5-12.93,9.75-33.62,13.95-44.66,73.76-190.7,247.27-85.26,347.56-133C973.43,168.67,979.49,174.05,977,179.83Z"/>
                            <path fill="#fff" d="M513.86,7c49.11,40.64,193,176.39,82.6,292.82-4.3,4.54-12,1.43-11.73-4.81,2.42-58.54-3-154.9-53.48-228,0,0,49.55,89.66,27.17,228V295q0,.11-.06.36c-.09.52-1.72,14.76,1.39,24.81-6.44,2.39-23.3-14.5-30.73-20C402.67,205.4,513.94,98.64,503.08,13.43,502.29,7.22,509.05,3,513.86,7Z"/>
                            <path fill="#fff" d="M869.63,562,437.12,244,4.6,562v638H312.25V958.59H554.62v155.05h-.27V1200H869.63Zm-86.19,551.63H646.13V675.36l-91.51-67.28v258H312.25V611.61L220.74,678.9v434.74H90.8V605.75l.49-.36-.07-.08L396.49,380.85l.07.07,40.56-29.82L783.44,605.75Z"/>
                          </svg>
                        </div>
                        <div class="absolute center bottom-0" style="bottom:4%;">
                          <p class="line-height-1 pt1 comely " style="font-size: clamp(2em, 2.5vw, 2.5em); font-family: comely;"  >Jeg er uddannet</p>
                          <p class="line-height-1 p0 mb1 bold " style="font-size: clamp(2.3em, 2.8vw, 2.5em);">Klimahåndværker</p>
                          <p class="line-height-1 regular h1" style="font-size: clamp(2em, 2.2vw, 2.3em);" >Byg med omtanke</p>
                        </div>
              </div>
              <button class="action-button p2 flex justify-start items-center h5 line-height-1 mr-auto my3" @click="downloadBadge('https://widget.haandvaerker.dk/klima/rendered/klima_'+haaId+'.jpg', 'klima_'+haaId)" :disabled="disableDownloadBtn">
                    <span></span><span>Download klimamærke</span>
              </button>
      </div>
      <!--Mail signature-->
      <div class="clearfix" v-if="show">
        <div class="col-12">
          <div class="loader"></div>
          <p class="center mediumgrey bold">Genererer badges ...</p>
        </div>
      </div>
      <div id="badgesImages" class="hide" v-if="displayAllBadges">
        <div class="col-12 flex m0 p0 mb2">
          <a type="button"  class="action-button  p2 h5 line-height-1 mx2 mb2" href="https://drive.google.com/drive/folders/1gxqIVum_74-es4BYUnV8MYGmOSj-O-9q?usp=sharing" target="_blank">
            <div class="inline-block">
              <p class="line-height-1 flex items-center m0">
                <span class="inline-block mr1 relative">
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="#fff" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                </span>
                <span class="inline-block">Billeder fra Herlev</span>
              </p>
            </div>
          </a>
          <a type="button" class="action-button  p2 h5 line-height-1 no-hover mx2 mb2" href="https://drive.google.com/drive/folders/1viPxZEyPC4CMOf1XyhsVT1s-i5P6Bdf-?usp=sharing" target="_blank">
            <div class="inline-block">
              <p class="line-height-1 flex items-center m0">
                <span class="inline-block mr1 relative">
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="#fff" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                </span>
                <span class="inline-block">Billeder fra Aarhus</span>
              </p>
            </div>
          </a>
        </div>
        <div class="col-12 flex flex-wrap mb2" :key="index" v-for="(badge, index) in badgemailsignature">
          <div class="col-12 px0 flex mobile-flex-column md-flex-column">
            <div class="col-6 px0">
              <div :id="'mail-'+badge" class="hide">
                <div class="mb4">
                  <div class="mb2">
                    <img  :src="'https://widget.haandvaerker.dk/prisen/winnersBadge/mail/rendered/'+haaId+'/'+badge+'.jpg'" @load="displaybadgerendere('mail', badge)">
                  </div>
                  <div>
                    <button class="action-button p2 flex justify-start items-center h5 line-height-1" @click="downloadBadge('https://widget.haandvaerker.dk/prisen/winnersBadge/mail/rendered/'+haaId+'/'+badge+'.jpg', badgesIndustryDatamail[index])" :disabled="disableDownloadBtn">
                      <span></span><span>Download mailsignatur</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-5 px2 mdpo">
              <div :id="'mailsmall-'+badge" class="hide">
                <div class="mb4">
                  <div class="mb2">
                    <img  :src="'https://widget.haandvaerker.dk/prisen/winnersBadge/mailsmall/rendered/'+haaId+'/'+badge+'.jpg'" @load="displaybadgerendere('mailsmall', badge)">
                  </div>
                  <div>
                    <button class="action-button p2 flex justify-start items-center h5 line-height-1" @click="downloadBadge('https://widget.haandvaerker.dk/prisen/winnersBadge/mailsmall/rendered/'+haaId+'/'+badge+'.jpg', badgesIndustryDatasmallmail[index])" :disabled="disableDownloadBtn">
                      <span></span><span>Download mailsignatur</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Streamer-->
        <div class="flex flex-wrap md-flex-column">
          <div class="md-col-6 lg-col-6 sm-col-12 xs-col-12 mb2 badgeside" :key="index+'-'+badge" v-for="(badge, index) in badges">
            <div class="col-12 px0">
              <div class="col-12 px0">
                <div>
                  <div class="mb4">
                    <div class="mb2">
                      <img rel="preload" :src="'https://widget.haandvaerker.dk/prisen/winnersBadge/streamer/rendered/'+haaId+'/'+badge+'.jpg'" @load="displayBadges('streamer', badge)">
                    </div>
                    <div>
                      <button class="action-button p2 flex justify-start items-center h5 line-height-1" @click="downloadBadge('https://widget.haandvaerker.dk/prisen/winnersBadge/streamer/rendered/'+haaId+'/'+badge+'.jpg', badgesIndustryData[index])" :disabled="disableDownloadBtn">
                        <span></span><span>Download banner til hjemmeside</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="nowinnerbadge">
        <span>Tak for interessen for dine badges. Du kan ringe til vores team om, hvordan du kan få badges til at generere</span>
      </div>
    </div>
    <ErrorHandler ref="errorMsg"></ErrorHandler>
  </div>
</template>
<style>
@media only screen and (min-width: 800px) {
  .adjust {
    margin-left: 4rem;
  }
}
</style>
<script>
import { ImageRating } from 'vue-rate-it'
import loading from 'vue-full-loading'
const ErrorHandler = () => import('@/components/ErrorHandler')
export default {
  name: '',
  components: {
    ImageRating,
    loading,
    ErrorHandler
  },
  data () {
    return {
      salesPerson: '',
      haaId: '',
      badges: 0,
      klimabadge: [],
      renderklima: false,
      badgesIndustryData: [],
      badgesIndustryDatamail: [],
      badgesIndustryDatasmallmail: [],
      badgesIndustryDatstreamer: [],
      renderMail: false,
      renderMailSmall: false,
      renderStreamer: false,
      loopStatusCheck: '',
      loopStatusCheckbadge: '',
      loopStatusCheckbadgemail: '',
      loopStatusCheckbadgesmall: '',
      show: false,
      label: '',
      overlay: true,
      nowinnerbadge: false,
      displayAllBadges: false,
      disableDownloadBtn: false,
      badgeRegion: '',
      badgemailsignature: '',
      eventLocation: '',
      partnerName: '',
      EventsImagesData: [{
        region: 'Nordjylland',
        location: 'Randers',
        link: 'https://drive.google.com/drive/folders/1fBBB83LOCvg77sZNkVF1BVrVu42vXksN?usp=sharing'
      },
      {
        region: 'Midtjylland',
        location: 'Randers',
        link: 'https://drive.google.com/drive/folders/1fBBB83LOCvg77sZNkVF1BVrVu42vXksN?usp=sharing'
      },
      {
        region: 'Syddanmark',
        location: 'Fredericia',
        link: 'https://drive.google.com/drive/folders/1QSHn6qxX0m59bY-g8P6bAqJ22lbMVDLA?usp=sharing'
      },
      {
        region: 'Sjælland',
        location: 'Slagelse',
        link: 'https://drive.google.com/drive/folders/1F1t8yWzw_z9EV7G6bz80X0nDVu5c3tsc?usp=sharing'
      },
      {
        region: 'Hovedstaden',
        location: 'Valby',
        link: 'https://drive.google.com/drive/folders/14y41MNrltCvXqAg908-lhb-BuWGFGeIC?usp=sharing'
      },
      {
        region: 'Nordsjælland',
        location: 'Hillerød',
        link: 'https://drive.google.com/drive/folders/1NXiNVcUVaA8-BhbkoHG76zan4BYvA4Fx?usp=sharing'
      }],
      EventsImagesData2022: [{
        region: 'west',
        location: 'Randers',
        link: 'https://drive.google.com/drive/folders/1gxqIVum_74-es4BYUnV8MYGmOSj-O-9q?usp=sharing'
      },
      {
        region: 'east',
        location: 'Randers',
        link: 'https://drive.google.com/drive/folders/1fBBB83LOCvg77sZNkVF1BVrVu42vXksN?usp=sharing'
      }],
      primaryBranchetext: ''
    }
  },
  methods: {
    nobadgeprisen () {
      this.nowinnerbadge = true
      this.show = false
      this.displayAllBadges = false
    },
    showtak () {
      this.show = false
      this.nowinnerbadge = true
    },
    getbitrixprofile () {
      /* eslint-disable no-unused-vars */
      this.show = true
      var data = {
      }
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/supplier/GetSupplierProfileById/' + this.haaId, data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success && res.data !== null) {
            var badgesListstreamer = res.data.c_prisen_result
            var badgesListmerge = res.data.mergedBadges
            var badgesList = res.data.c_prisen_result
            var primary = res.data.c_primary_industry.BRANCH_ID
            this.primaryBranchetext = res.data.c_primary_industry.BUSINESS
            // klima 
            var klimafilteredBadge = res.data.c_supplier_badge.filter(function (property) {
              return property['BADGE_TYPE'] === 'craftsman-education' && property['TITLE'] === 'Klima' && property['IS_OK'] === true
            })
            this.klimabadge = klimafilteredBadge
            if (this.klimabadge.length > 0) {
              this.displayklimaBadge()
            }
            // if no prisen badge  and klima
            if (badgesList.length === 0) {
              this.nobadgeprisen()
              this.show = true
              return false
            }
            if (badgesList.length === 0 && klimafilteredBadge.length === 0) {
              this.showtak()
              this.show = true
              return false
            }
            // get all merge in the service
            var badgeids = []
            badgesListmerge.forEach(function (property, index) {
              badgeids.push(index + 1)
            })
            badgesList.forEach(function (property, index) {
              badgeids.push(badgeids.length + 1)
            })
            this.badgemailsignature = badgeids
            this.badges = badgeids
            // // mail
            // var mergebadgee = this.mergedBadgesbitrixmail(badgesList, primary)
            // this.badgesIndustryDatamail = Object.keys(mergebadgee)
            // this.badgesIndustryDatasmallmail = Object.keys(mergebadgee)
            // var badgeid = []
            // for (var badge in mergebadgee) {
            //   var badgsplit = badge.split(' ')
            //   var rowbolig = {
            //     'INDUSTRY_ID': parseInt(badgsplit[badgsplit.length - 1])
            //   }
            //   badgesList.unshift(rowbolig)
            // }
            // badgesList.forEach(function (property, index) {
            //   badgeid.push(index + 1)
            // })
            // // streamer
            // var badgeidstreamer = []
            // var streamline = this.getstreamerbadge(badgesListstreamer, primary)
            // this.badgesIndustryData = Object.keys(streamline)
            // streamline.forEach(function (property, index) {
            //   badgeidstreamer.push(index + 1)
            // })
            // this.badgemailsignature = badgeid
            // this.badges = badgeidstreamer
            var thisVar = this
            this.loopStatusCheck = window.setInterval(function () {
              // thisVar.checkImgStatus('mail')
              // thisVar.checkImgStatus('mailsmall')
              thisVar.checkImgStatus('streamer')
              thisVar.checkImgStatus('klima')
            }, 2000)
          } else {
            this.$message({
              type: 'error',
              message: 'Error in getbitrixprofile() ' + res.message
            })
            this.showtak()
            this.show = false
          }
        },
        (err) => {
          this.$message({
            type: 'error',
            message: 'Error in getbitrixprofile() ' + err.body.message
          })
          this.show = false
        }
      )
    },
    getBadgesCount () {
      this.show = true
      /* eslint-disable no-unused-vars */
      var data = {
        operation: 'oversigt_getsupplierprofilebyid',
        levid: this.haaId,
        salesPerson: this.salesPerson
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          var badgesList = res.Badges
          var filteredBadges = badgesList.filter(function (property) {
            return property['Industry'] != null
          })
          var klimafilteredBadge = badgesList.filter(function (property) {
            return property['BadgeType'] === 'craftsman-education' && property['Title'] === 'Klima' && property['IsOK'] === true
          })
          // console.log('klimafilteredBadge ', klimafilteredBadge)
          // console.log('filteredBadges ', filteredBadges)
          this.klimabadge = klimafilteredBadge
          if (this.klimabadge.length > 0) {
            this.displayklimaBadge()
          }
          if (filteredBadges.length === 0 && klimafilteredBadge.length === 0) {
            this.showtak()
            return false
          }
          if (filteredBadges.length === 0) {
            this.nobadgeprisen()
            return false
          }
          if (filteredBadges.length === 0 && klimafilteredBadge.length === 0) {
            this.showtak()
            return false
          }
          var badgesArr = this.mergedBadges(filteredBadges)
          this.badgesIndustryData = Object.keys(badgesArr)
          var badgesCount = 0
          for (var badge in badgesArr) {
            var region = badge.split(' ')
            this.badgeRegion = region[1]
            badgesCount++
          }
          this.badges = badgesCount
          var thisVar = this
          this.loopStatusCheck = window.setInterval(function () {
            thisVar.checkImgStatus('streamer')
            thisVar.checkImgStatus('klima')
          }, 2000)
        },
        (err) => {
          console.log('Error in getBadgesCount()', err)
          this.show = false
        }
      )
    },
    getstreamerbadge (badgearr) {
      var items = badgearr.filter((a) => {
        return a.PRISEN_ID !== null && typeof a.PRISEN_ID !== 'undefined'
      })
      badgearr = items
      var mergebadgeestreamer = this.mergedBadgesbitrixstreamer(badgearr)
      var objectdata = Object.values(mergebadgeestreamer)
      objectdata.forEach(a => {
        var badgsplits = a.split(',')
        if (badgsplits.length > 1) {
          var rowboligs = {
            'INDUSTRY_ID': parseInt(badgsplits[badgsplits.length - 2]),
            'AREA': badgsplits[badgsplits.length - 1].split('-')[0]
          }
          badgearr.unshift(rowboligs)
        }
      })
      this.badgesIndustryDatstreamer = Object.keys(mergebadgeestreamer)
      return badgearr
    },
    gotoArtikel () {
      this.$router.push('/artikel')
    },
    displayklimaBadge () {
      document.getElementById('klimabadge').classList.remove('hide')
      // this.getEventImages()
      // this.show = false
    },
    displaybadgerendere (badgetype, index) {
      var imagesmail = document.getElementById(badgetype + '-' + index)
      var itemarr = this.badgemailsignature.length
      var lastitemmail = this.badgemailsignature[itemarr - 1]
      imagesmail.classList.remove('hide')
      if (lastitemmail === index) {
        this.show = false
      }
      // var thisVar = this
      // this.loopStatusCheckbadgemail = window.setInterval(function () {
      //   thisVar.checkImgStatus('mail', index)
      // }, 2000)
      // this.loopStatusCheckbadgesmall = window.setInterval(function () {
      //   thisVar.checkImgStatus('mailsmall', index)
      // }, 2000)
    },
    displayBadges (badge, badgesCount) {
      // if ((badge === 'streamer' || badge === 'mail') && this.badges === badgesCount) {
      if (badge === 'streamer') {
        document.getElementById('badgesImages').classList.remove('hide')
        this.getEventImages()
        this.show = false
      }
    },
    checkImgStatus (badge, index = 0) {
      if (badge === 'mail' || badge === 'mailsmall') {
        var m = this
        this.badgemailsignature.forEach((a) => {
          this.getStatus(badge, 'https://widget.haandvaerker.dk/prisen/winnersBadge/mail/rendered/' + m.haaId + '/' + a + '.jpg', index)
          this.getStatus(badge, 'https://widget.haandvaerker.dk/prisen/winnersBadge/mailsmall/rendered/' + m.haaId + '/' + a + '.jpg', index)
        })
      } else if (badge === 'klima') {
        this.getStatus(badge, 'https://widget.haandvaerker.dk/klima/rendered/klima_' + this.haaId + '.jpg')
      } else {
        var mm = this
        this.badges.forEach((b) => {
          this.getStatus(badge, 'https://widget.haandvaerker.dk/prisen/winnersBadge/' + badge + '/rendered/' + mm.haaId + '/' + b + '.jpg')
        })
      }
    },
    getStatus (badge, url, index = 0) {
      var request = new XMLHttpRequest()
      var thisVar = this
      // console.log('request', request)
      request.onreadystatechange = function () {
        if (request.readyState === 4) {
          if (request.status === 200) {
            if (badge === 'mail') {
              clearInterval(thisVar.loopStatusCheckbadgemail)
              var imagesmail = document.getElementById('imagemail-' + index)
              imagesmail.classList.remove('hide')
              thisVar.displayAllBadges = true
            }
            if (badge === 'mailsmall') {
              clearInterval(thisVar.loopStatusCheckbadgesmall)
              var imagesmailsmall = document.getElementById('imagemailsmall-' + index)
              imagesmailsmall.classList.remove('hide')
              thisVar.displayAllBadges = true
            }
            if (badge === 'streamer') {
              clearInterval(thisVar.loopStatusCheck)
              thisVar.displayAllBadges = true
            }
          } else {
            if (badge === 'mail') {
              thisVar.renderMail = true
            } else if (badge === 'mailsmall') {
              thisVar.renderMailSmall = true
            } else if (badge === 'klima') {
              thisVar.renderklima = true
            } else {
              thisVar.renderStreamer = true
            }
          }
        }
      }
      request.open('GET', url, true)
      request.send()
    },
    downloadBadge (url, title) {
      this.disableDownloadBtn = true
      var data = {
        operation: 'badgeDownload',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        url: url
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.login === false) {
            this.$router.push('/login')
          }
          if (res.success) {
            const linkSource = 'data:image/png;base64,' + encodeURI(res.url)
            const downloadLink = document.createElement('a')
            const fileName = 'badge_' + this.partnerName + '.png'
            downloadLink.href = linkSource
            downloadLink.download = fileName
            downloadLink.click()
            this.disableDownloadBtn = false
          } else {
            this.disableDownloadBtn = false
            console.log('Error in downloadBadge()', response)
          }
        },
        (err) => {
          this.disableDownloadBtn = false
          console.log('Error in downloadBadge()', err)
        }
      )
    },
    mergedBadgesbitrixmail (filteredBadges, industryid = 1) {
      var industryAreaYear = []
      var badgeplace = ''
      for (var i = 0; i < filteredBadges.length; i++) {
        if (filteredBadges[i]['INDUSTRY_NAME'] === 'TV inspektion') {
          filteredBadges[i]['INDUSTRY_NAME'] = 'TVInspektion'
        }
        badgeplace = filteredBadges[i]['PLACE']
        if (filteredBadges[i]['PLACE'] > 1) {
          badgeplace = 'Finalist'
        }
        var temp = filteredBadges[i]['INDUSTRY_NAME'] + '' + filteredBadges[i]['AREA'].replace('Region', '') + ' ' + badgeplace + ' ' + industryid
        if (typeof industryAreaYear[temp] === 'undefined') {
          industryAreaYear[temp] = filteredBadges[i]['YEAR'] + '-' + badgeplace + '-' + badgeplace + '-' + filteredBadges[i]['AREA'].replace('Region', '')
        } else {
          industryAreaYear[temp] = industryAreaYear[temp] + ',' + filteredBadges[i]['YEAR'] + '-' + badgeplace + '-' + filteredBadges[i]['AREA'].replace('Region', '')
        }
      }
      return industryAreaYear
    },
    mergedBadgesbitrixstreamer (filteredBadgess) {
      var items = filteredBadgess.filter((a) => {
        return a.PRISEN_ID !== null && typeof a.PRISEN_ID !== 'undefined'
      })
      filteredBadgess = items
      var industryAreaYears = []
      for (var e = 0; e < filteredBadgess.length; e++) {
        if (filteredBadgess[e]['INDUSTRY_NAME'] === 'TV inspektion') {
          filteredBadgess[e]['INDUSTRY_NAME'] = 'TVInspektion'
        }
        var badgeplace = filteredBadgess[e]['PLACE']
        if (filteredBadgess[e]['PLACE'] > 1) {
          badgeplace = 'Finalist'
        }
        var temps = filteredBadgess[e]['INDUSTRY_NAME'] + '' + filteredBadgess[e]['AREA'].replace('Region', '') + ' ' + badgeplace
        if (typeof industryAreaYears[temps] === 'undefined') {
          industryAreaYears[temps] = filteredBadgess[e]['YEAR'] + '-' + badgeplace
        } else {
          industryAreaYears[temps] = industryAreaYears[temps] + ',' + filteredBadgess[e]['YEAR'] + '-' + badgeplace
        }
      }
      return industryAreaYears
    },
    mergedBadges (filteredBadges) {
      var industryAreaYear = []
      for (var i = 0; i < filteredBadges.length; i++) {
        if (filteredBadges[i]['Industry'] === 'TV inspektion') {
          filteredBadges[i]['Industry'] = 'TVInspektion'
        }
        var temp = filteredBadges[i]['Industry'] + '' + filteredBadges[i]['Area'].replace('Region', '') + ' ' + filteredBadges[i]['Position']
        if (industryAreaYear[temp] !== null) {
          industryAreaYear[temp] = filteredBadges[i]['BadgeYear'] + '-' + filteredBadges[i]['Position']
        } else {
          industryAreaYear[temp] = industryAreaYear[temp] + ',' + filteredBadges[i]['BadgeYear'] + '-' + filteredBadges[i]['Position']
        }
      }
      return industryAreaYear
    },
    getEventImages () {
      var events = this.EventsImagesData
      for (var i = 0; i < events.length; i++) {
        if (events[i].region === this.badgeRegion) {
          document.getElementById('eventsImages').href = events[i].link
          this.eventLocation = events[i].location
        }
      }
    }
  },
  created () {
    this.partnerName = localStorage.getItem('CompanyName')
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    this.getbitrixprofile()
  }
}
</script>
<style>
  #digital-pakke a:hover:after {
    display: none;
  }
  #digital-pakke  a.download-btn {
    background-color: transparent;
  }
  #digital-pakke  a.download-btn span {
    color: #4dcf55;
  }
  #digital-pakke  a.download-btn svg {
    color: #4dcf55;
  }
  #digital-pakke  a.download-btn:hover svg {
    stroke: #fff!important;
  }
  #digital-pakke  a.download-btn:hover span {
    color: #fff;
  }
  #digital-pakke  .loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
  #digital-pakke  .loader {
    color: #143130;
    font-size: 11px;
    text-indent: -99999em;
    margin: 55px auto;
    position: relative;
    width: 10em;
    height: 10em;
    box-shadow: inset 0 0 0 1em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  #digital-pakke .loader:before,
  .loader:after {
    position: absolute;
    content: '';
  }
  #digital-pakke  .loader:before {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    -webkit-transform-origin: 5.2em 5.1em;
    transform-origin: 5.2em 5.1em;
    -webkit-animation: load2 2s infinite ease 1.5s;
    animation: load2 2s infinite ease 1.5s;
  }
  #digital-pakke  .loader:after {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 5.1em;
    -webkit-transform-origin: 0px 5.1em;
    transform-origin: 0px 5.1em;
    -webkit-animation: load2 2s infinite ease;
    animation: load2 2s infinite ease;
  }
  @-webkit-keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @media (max-width:115em) {
    .md-flex-column {
      flex-direction: column!important;
    }
    .mdpo {
      padding: 0!important;
    }
  }
  @media (max-width: 1355px) {
    #badgesImages .badgeside {
      width: 100%!important;
    } 
  }
</style>



// WEBPACK FOOTER //
// badges.vue?1e40d95e